/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Title_AccentInputs */

const en_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clinics.`)
};

const es_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clínicas.`)
};

const de_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurse.`)
};

const zh_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`训练班。`)
};

const ar_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الورش التدريبية.`)
};

const fr_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stages.`)
};

const vi_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lớp chuyên đề.`)
};

const sw_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mafunzo.`)
};

const th_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลินิกกอล์ฟ`)
};

const bs_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kursevi.`)
};

const ja_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリニック`)
};

const ko_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클리닉.`)
};

const pt_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clínicas.`)
};

const it_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clinic.`)
};

const sv_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurser.`)
};

const nl_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clinics.`)
};

const da_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurser.`)
};

const nb_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurs.`)
};

const fi_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurssit.`)
};

const pl_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`szkolenia.`)
};

const ru_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`мастер-классы.`)
};

const tr_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eğitim programları.`)
};

const hi_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रशिक्षण सत्र।`)
};

const id_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kelas.`)
};

const ms_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kelas.`)
};

const cs_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kurzy.`)
};

const el_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`σεμινάρια.`)
};

const he_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`וסדנאות`)
};

const af_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kursusse.`)
};

const hu_events_title_accent = /** @type {(inputs: Events_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tanfolyamok.`)
};

/**
* | output |
* | --- |
* | "clinics." |
*
* @param {Events_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_title_accent = /** @type {((inputs?: Events_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_title_accent(inputs)
	if (locale === "de") return de_events_title_accent(inputs)
	if (locale === "zh") return zh_events_title_accent(inputs)
	if (locale === "ar") return ar_events_title_accent(inputs)
	if (locale === "fr") return fr_events_title_accent(inputs)
	if (locale === "vi") return vi_events_title_accent(inputs)
	if (locale === "sw") return sw_events_title_accent(inputs)
	if (locale === "th") return th_events_title_accent(inputs)
	if (locale === "bs") return bs_events_title_accent(inputs)
	if (locale === "ja") return ja_events_title_accent(inputs)
	if (locale === "ko") return ko_events_title_accent(inputs)
	if (locale === "pt") return pt_events_title_accent(inputs)
	if (locale === "it") return it_events_title_accent(inputs)
	if (locale === "sv") return sv_events_title_accent(inputs)
	if (locale === "nl") return nl_events_title_accent(inputs)
	if (locale === "da") return da_events_title_accent(inputs)
	if (locale === "nb") return nb_events_title_accent(inputs)
	if (locale === "fi") return fi_events_title_accent(inputs)
	if (locale === "pl") return pl_events_title_accent(inputs)
	if (locale === "ru") return ru_events_title_accent(inputs)
	if (locale === "tr") return tr_events_title_accent(inputs)
	if (locale === "hi") return hi_events_title_accent(inputs)
	if (locale === "id") return id_events_title_accent(inputs)
	if (locale === "ms") return ms_events_title_accent(inputs)
	if (locale === "cs") return cs_events_title_accent(inputs)
	if (locale === "el") return el_events_title_accent(inputs)
	if (locale === "he") return he_events_title_accent(inputs)
	if (locale === "af") return af_events_title_accent(inputs)
	if (locale === "hu") return hu_events_title_accent(inputs)
	return en_events_title_accent(inputs)
});